// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown__dropdown___24Skc _type__vx_text-5_lighter___2ilC-"};